import { render } from "./QuemSomos2.vue?vue&type=template&id=aba2b4dc"
import script from "./QuemSomos2.vue?vue&type=script&lang=js"
export * from "./QuemSomos2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__